<template>
  <BLayoutList
    :create-route="createRoute"
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableMarks
      v-model="selected"
      :list="list"
      :headers="TABLE_HEADERS"
      :actions="TABLE_ACTIONS"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      :sessions="sessions"
      show-expand
      single-expand
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:download="onDownload"
      @action:upload="(e) => onUpload(e, 'QUESTIONS')"
      @action:accept="(e) => onUpload(e, 'VEER')"
      @action:update="(e) => onUpload(e, 'MARKS')"
      @action:generate="onVeersGenerate"
      @action:convert="onConvert"
      @action:positions_upload="(e) => onUpload(e, 'TASKS_ORDER')"
    >
      <template #item.questions_uploaded="{ data }">
        <v-icon
          class="mr-2"
          v-text="data.questions_uploaded ? 'mdi-check' :'mdi-close'"
        />
      </template>

      <template #item.task_order_uploaded="{ data }">
        <v-icon
          v-if="data.procedure_type === 'GRAMOTNOST'"
          class="mr-2"
          v-text="data.task_order_uploaded ? 'mdi-check' :'mdi-close'"
        />
      </template>

      <template #expanded-item="{ data, headers }">
        <td :key="data.procedure_id" :colspan="headers.length" class="pa-4">
          <JournalView :procedure-id="data.procedure_id" />
        </td>
      </template>
    </BTableMarks>
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { MarksModel as Model } from './Model'
import { MARKS_ROUTES as ROUTES, createMarksModal } from './utils'
import {
  marksStoreModule as StoreModule,
  marksMapper as StoreMapper,
} from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import ComponentFilter from './components/PublicationsFilter.vue'
import { MarksApi, VeersApi } from '@/api/resources/Marks'
import { TABLE_HEADERS, TABLE_ACTIONS } from './table-headers'
import BTableMarks from '@/components/tables/BTableCommon/BTableMarks.vue'
import JournalView from './components/Journal/View.vue'

const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewMarksList',
  components: {
    JournalView,
    BLayoutList,
    BTableMarks,
    ComponentFilter,
  },
  mixins: [listMixin],
  data: () => ({
    TABLE_HEADERS,
    TABLE_ACTIONS,
  }),
  computed: {
    ...StoreMapper.mapState(['sessions']),
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  methods: {
    catchError(e) {
      const message = e?.data?.message
      if (message) {
        this.$notice.error(message)
      } else {
        this.$notice.errors(e)
      }
    },
    async onDownload({ procedure_id }, callback) {
      const unwatch = callback?.()
      const api = new MarksApi()
      try {
        await api.report(procedure_id)
        this.$notice.info(
          'Итоговая выгрузка формируется. После завершения процесса вы получите сообщение в разделе уведомления',
        )
      } catch (e) {
        this.catchError(e)
      }
      unwatch?.()
    },
    onUpload({ procedure_id }, which) {
      this.$router.push({
        name: ROUTES.UPLOAD,
        query: {
          procedure_id,
          which,
        },
      })
    },
    async onVeersGenerate({ procedure_id }, callback) {
      const unwatch = callback?.()
      const api = new VeersApi()
      try {
        await api.generate(procedure_id)
        this.$notice.info(
          'После завершения процесса вы получите сообщение в разделе уведомления',
        )
      } catch (e) {
        this.catchError(e)
      }
      unwatch?.()
    },
    async onConvert({ procedure_id: procedureId }, callback) {
      const propsData = { procedureId }
      const modal = await createMarksModal(this, propsData)
      const unwatch = callback?.()
      await modal.open()
      unwatch?.()
    },
  },
}
</script>
